<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-product-documents-ipr-standard-clause-list" class="ag-grid-container">

    <div class="vx-card">
      <grid-panel
          :column-defs="columnDefs"
          height="xl"
          ref="grid"
          :url="() => documentList"
          :auto-size="true"
          @rowClicked="edit"
          title="Standard Clause"
      >
        <vs-dropdown-item v-if="componentAccess.canCreate.access">
          <span
              class="flex items-center"
              @click="$router.push({ name: `${ProductCompanyType}.standard-clause-ipr.create` })"
          >
            <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Create New Standard Clause</span>
          </span>
        </vs-dropdown-item>
      </grid-panel>

    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import CellRendererVerified from "@/views/components/ag-grid/cell-renderer/CellRendererVerified";

export default {
  components: {
    TGrid,
    GridPanel,
    CellRendererVerified,
  },
  mixins: [CellMatchingMixin,CanAccessMixin,IprProductCompanyTypeMixin],
  data () {
    return {
      searchQuery: '',
      showDeleted: false,
      documentList: [],
      componentAccess: {
        canCreate: {
          route: `${this.ProductCompanyType}.standard-clause-ipr.create`,
          access: false,
        },
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'Friendly Name',
          field: 'FriendlyName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'File',
          field: 'FileName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Standard Clause',
          field: 'StandardClause',
          filter: 'agTextColumnFilter',
        },
      ],
    }
  },
  watch: {
    ProductCompanyType_FK: {
      async handler() {
        await this.getDocuments();
        this.$refs.grid.list();
      },
      immediate: true,
    },
  },
  methods: {
    async getDocuments() {
      this.documentList = await this.$api[this.companyTypeApiModel('productStandardClauseIpr')].list();

      return this.documentList;
    },
    edit({data}) {
      this.$router.push({ name: `${this.ProductCompanyType}.standard-clause-ipr.edit`, params: { id: data.id }}).catch(() => {});
    }
  },
}

</script>

<style lang="scss">
</style>
